import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchGradeData = createAsyncThunk("api/grade", async () => {
  const response = await fetch(`${FULL_API_BASE_URL}/get-job-grade-list`);
  const data = await response.json();
  return data;
});

const departmentSlice = createSlice({
  name: "grade",
  initialState: {
    gradedata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGradeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGradeData.fulfilled, (state, action) => {
        state.loading = false;
        state.gradedata = action.payload;
      })
      .addCase(fetchGradeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default departmentSlice.reducer;
